import React from "react";
import LandLordTable from "../../components/Table/LandLordTable";
import { landlordPayouts } from "../../components/Data/landlordPayouts";

const transformedPayouts = landlordPayouts.map((item, index) => ({
  key: `payout-${index}`,
  id: item.date,
  unitName: item.landlordName,
  deposit: item.bank,
  rent: item.grossAmount,
  commission: item.commission, 
  tenantName: item.netAmount,
  phone: item.status,
  status: item.referenceId,
  payments: [item],
}));

const columns = [
  { title: "Date / Time", dataIndex: "id", key: "id" },
  { title: "Landlord Name", dataIndex: "unitName", key: "unitName" },
  { title: "Bank / Mobile Wallet", dataIndex: "deposit", key: "deposit" },
  {
    title: "Gross Amount",
    dataIndex: "rent",
    key: "rent",
  },
  {
    title: "Platform Commission",
    dataIndex: "commission",
    key: "commission",
    render: (value) => (
      <span className="text-[#707070] font-inter">{value}</span>
    ),
  },
];

const subTableConfig = {
  dataField: "payments",
  columns: [
    { title: "Net amount paid", dataIndex: "netAmount", key: "netAmount" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <span
          className="font-semibold"
          style={{
            color: status === "Paid" ? "#4bea85" : "#F97316", // green-600 / orange-500
          }}
        >
          {status}
        </span>
      ),
    },
    { title: "Reference ID", dataIndex: "referenceId", key: "referenceId" },
  ],
};

const LandLordPayoutPage = () => {
  return (
    <div className="p-6">
      <h2 className="text-lg font-semibold text-gray-700 mb-4">
        Landlord Payouts
      </h2>
      <LandLordTable
        dataSource={transformedPayouts}
        columns={columns}
        hasSubTable={true}
        subTableConfig={subTableConfig}
        rowKey="key"
        />
    </div>
  );
};

export default LandLordPayoutPage;
